import React from 'react';
import Image from 'react-bootstrap/Image';

function HsImage(props) {
  const { type } = props;
  console.log('type', type);

  let fallbackSrc = '/api/static/placeholder.png';
  if (type === 'user') {
    fallbackSrc = '/api/static/placeholder.png';
  }

  return (
    <Image
      fluid
      {...props}
      src={props.src ? props.src : fallbackSrc}
      onError={(e) => {
        const target = e.target;
        target.onError = null;
        target.src = fallbackSrc;
      }}
    />
  );
}

export default HsImage;
